export default __webpack_public_path__ + "static/media/software-pos.447e589a.png";